export default function getStamp ($element) {
    const stamp = $element.children('[stamp]')[0];
    const hasStamp = Boolean(stamp);
    const stampClasses = hasStamp && $(stamp).data('stamp-class') || '';
    return { hasStamp, stampClasses };
}
